module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm03_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Copyright © 2013 by Aaron McDaniel")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNG")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFESSIONAL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UIDE TO")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANAGING")]), _c('br'), _vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DITED AND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YPESET BY")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARA")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMPEL")])]), _c('br'), _vm._v("Cover design by Howard Grossman/12E Design"), _c('br'), _vm._v("Printed in the U.S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The Career Press, Inc."), _c('br'), _vm._v("220 West Parkway, Unit 12"), _c('br'), _vm._v("Pompton Plains, NJ 07444"), _c('br'), _c('strong', [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.careerpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.careerpress.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1a"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:"), _c('br'), _vm._v("McDaniel, Aaron.")]), _vm._v(" "), _c('p', {
    staticClass: "copyb"
  }, [_vm._v("The young professional’s guide to managing : building, guiding, and motivating your team to achieve awesome results / by Aaron McDaniel.")]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "copyb"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyb"
  }, [_vm._v("ISBN 978-1-60163-254-8 (print) -- ISBN 978-1-60163-541-9 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyc1"
  }, [_vm._v("1. Management. 2. Supervision of employees. 3. Employee motivation. 4. Teams in the workplace. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyc2"
  }, [_vm._v("HD31.M3829 2013"), _c('br'), _vm._v("658.4’022--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyc3"
  }, [_vm._v("2013007281")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e17ba4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_copy.vue
// module id = 63
// module chunks = 0